import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Paper} from '@material-ui/core/'
import TableRowsJ from './TableRow'
import { getToDoListByUser,getMoteByID,getCurrentTodo } from 'actions'
import {isEmpty} from 'lodash'
import CustomScrollbars from "util/CustomScrollbars";
import moment from 'moment-timezone'
import { withRouter } from "react-router-dom";
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,Intranet}) {
    const { authUser} = auth;
    const { AttgoraList} = Intranet;
    return {
        authUser,AttgoraList
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getToDoListByUser: (userid, Afid) => dispatch(getToDoListByUser(userid, Afid)),
        getMoteByID: (Orgrn, Afid, userid, Event) => dispatch(getMoteByID(Orgrn, Afid, userid, Event)),
        getCurrentTodo: (Afid,Userid,Todoid) => dispatch(getCurrentTodo(Afid,Userid,Todoid)),
        dispatch 
    };
}
function createData(type, date, customer) {
    return {
        type,
        date,
        customer,
        info: [
            { text: 'TEXT' },
        ],
    };
}
const rows = [
   /**/ createData("Möte", "2020-06-12", "IKEA"),
    createData("Aktivitet", "2020-06-12", "Volvo"),
    createData("Aktivitet", "2020-06-12", "Notyfile AB"),
    createData("Möte", "2020-06-12", "Skanska"),
    createData("Möte", "2020-06-12", "Axfood"),
    
];
class AttgöraTabell extends Component {
    state={
        AttgoraList: []

    }
    componentWillMount=()=>{
            const userid = this.props.authUser.user_id;
            const Afid = this.props.authUser.user_Afid;
            this.props.getToDoListByUser(userid, Afid) 
      
    }
    GotoAktivitet=(row)=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        this.props.history.push({
            pathname: '/app/Aktiviteter'
          })
        //get Aktivitet
        this.props.getCurrentTodo(Afid, userid, row.EventId)
    }
    GotoMote=(row)=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        this.props.getMoteByID(row.Orgnr, Afid, userid, row.EventId)
    }
    render() {
        const CurrentDateTime = moment(new Date().toLocaleString("sv-SE")).format("YYYY-MM-DD HH:mm")
        return (
            <TableContainer component={Paper}>
            <div className="text-center">
                <h1 style={{ paddingTop: '12px' }}><IntlMessages id="sidebar.appModule.toDo"/></h1>
            </div>
            <CustomScrollbars
          className="module-side-scroll scrollbar"
          style={{
            height:"calc(100vh - 250px)"
          }}
          >
            <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell><IntlMessages id="Type.label"/></TableCell>
                        <TableCell align="left"><IntlMessages id="Input.date"/>:</TableCell>
                        <TableCell align="left"><IntlMessages id="Table.Customer"/>:</TableCell>
                        <TableCell align="left"></TableCell>
                        {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell> */}
                        {/* <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
                    </TableRow>
                </TableHead>
                
                <TableBody >
                    {
                        isEmpty(this.props.AttgoraList)?"":
                        this.props.AttgoraList.map((row) => (
                            <TableRowsJ 
                            key={row.name} 
                            row={row} 
                            CurrentDateTime={CurrentDateTime}
                            GotoMote={this.GotoMote}
                            GotoAktivitet={this.GotoAktivitet}
                            />
                        ))
                    }
                </TableBody>
                
            </Table>
            </CustomScrollbars>
        </TableContainer>
        );
    }
}

export default withRouter(connect(
    mapStateToProps,mapDispatchToProps
)(AttgöraTabell));





